export default __webpack_public_path__ + "static/media/Gesture icons_Rub-18.51f562bb.svg";